export const NAVBAR_STATE_KEY = 'navbar';
